export default function composeReducers(...reducers) {
    return function composed(state, action) {
        for (let i = 0; i < reducers.length; i++) {
            const reducer = reducers[i];
            state = reducer(state, action);
        }
        return state;
    };
}
